angular.module('backstage.directives.theme-editor', [])
    .directive('componentTheme', require('./componentTheme'))
    .directive('themeEditorControl', require('./themeEditorControl'))
    .directive('themeEditorDropzone', require('./themeEditorDropzone'))
    .directive('themeEditorHighlightSelector', require('./themeEditorHighlightSelector'))
    .directive('themeEditorPreviewAffix', require('./themeEditorPreviewAffix'))
    .directive('miniThemePreview', require('./themePreview'));
